/**
 * What GITHUB_PACKAGES_TOKEN is for and what kind of token it must be, with
 * GitHub's page for creating one: shown wherever the token is asked for or set.
 */
import { GITHUB_PACKAGES_TOKEN_HELP, GITHUB_PACKAGES_TOKEN_URL, GITHUB_PACKAGES_TOKEN_VARIABLE } from "@yagni/shared";

export function isGithubPackagesToken(name: string): boolean {
  return name === GITHUB_PACKAGES_TOKEN_VARIABLE;
}

export function GithubPackagesTokenHelp() {
  return (
    <span data-testid="github-packages-token-help">
      {GITHUB_PACKAGES_TOKEN_HELP}{" "}
      <a href={GITHUB_PACKAGES_TOKEN_URL} target="_blank" rel="noreferrer">
        Create the token on GitHub
      </a>
    </span>
  );
}
